import { catchError } from "@opendash/core";
import Parse from "parse";
import { useEffect, useState } from "react";
import { Message } from "../../../js/parsegenerated";

type Props = (
  | {
      id: string;
      classname: string;
      obj?: never;
    }
  | {
      id?: never;
      classname?: never;
      obj: Parse.Object;
    }
) & { reload?: boolean };

export const useMessages = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [messages, setMessages] = useState<Message[]>([]);

  async function fetchMessages() {
    setLoading(true);
    const query = new Parse.Query(Message);
    query.equalTo("referencedObjectId", props.obj?.id ?? props.id);
    query.equalTo("classname", props.obj?.className ?? props.classname);
    query.descending("displayAt");
    const results = await query.find();
    setMessages(results);
    setLoading(false);
  }

  useEffect(() => {
    catchError(fetchMessages()).then((response) => {
      const [error] = response;
      if (error) {
        console.error("Error fetching messages", error);
      }
    });
  }, [props.reload]);

  return { loading, messages, fetchMessages };
};
